import { Button, ButtonKind } from '@aposphaere/ui-components'
import React from 'react'
import { StepStates, useCalendarPanel } from './CalendarPanelContext'
import { useRoutePlanner } from '../../contexts/routePlannerContext'

export const Navigation = ({
  step,
  onClose,
  disabled = false,
  setRouteForAppointment,
}: {
  step: StepStates
  onClose: () => void
  disabled: boolean
  setRouteForAppointment?: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const { goTo, setSelectedTime, setSelectedOrderItems } = useCalendarPanel()
  const { setRouteResponse, setSelectedDay } = useRoutePlanner()

  const handleOnClick = () => {
    setRouteResponse(null)
    setSelectedTime(new Date())
    setSelectedDay(undefined)
    if (onClose) {
      onClose()
      setRouteForAppointment?.(false)
    }
  }

  if (step === StepStates.DateSelection) {
    return (
      <div className="z-9999 px-2.5 py-3.5 absolute flex justify-between items-center bg-white bottom-0 w-full">
        <Button kind={ButtonKind.outlinedPrimary} onClick={handleOnClick}>
          Abbrechen
        </Button>
        <Button disabled={disabled} kind={ButtonKind.primary} onClick={() => goTo(StepStates.DetailsSection)}>
          Weiter
        </Button>
      </div>
    )
  }
  if (step === StepStates.DetailsSection) {
    return (
      <div className="z-9999 px-2.5 py-3.5 absolute flex justify-between items-center bg-white bottom-0 w-full">
        <Button
          kind={ButtonKind.outlinedPrimary}
          onClick={() => {
            goTo(StepStates.DateSelection)
            setSelectedOrderItems([])
          }}
        >
          Zurück
        </Button>
        <Button disabled={disabled} kind={ButtonKind.secondaryGreen} type="submit">
          Anlegen
        </Button>
      </div>
    )
  }
  return null
}
